import React, { FC, useState } from 'react';
import { MutationFunction } from 'react-apollo';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@material-ui/core';
import { map } from 'lodash';

import { UpdateClientFollowMappingComponent, ClientFollowMapping, Scalars } from 'api';
import { DepartmentPicker } from 'components/Pickers';
import { useNotify } from 'hooks';

type DepartmentIds = Array<Scalars['ID']>;

import { EMPTY_FOLLOW_CONDITIONS } from './constants';

interface IProps {
  mapping: ClientFollowMapping;
}

const DepartmentsEdit: FC<IProps> = ({ mapping }) => {
  const notify = useNotify();
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [ids, setIds] = useState(map(getFollowConditions().departments, 'id'));

  function getRequiredValues() {
    const { id, title, mapping_status, all_users } = mapping;
    return { id, title, mapping_status, all_users };
  }

  function getFollowConditions() {
    return mapping.follow_conditions || EMPTY_FOLLOW_CONDITIONS;
  }

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
    setSaving(false);
  }

  function handleChange(mutation: MutationFunction, departmentIds: DepartmentIds) {
    setSaving(true);
    setIds(departmentIds); // optimistic ;)
    return mutation({
      variables: {
        data: {
          ...getRequiredValues(),
          follow_conditions: {
            department_id: departmentIds,
            location_id: getFollowConditions().location_id || [],
          },
        },
      },
    });
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Box mt={2}>
          <Typography variant="subtitle2">{t('common:department_plural')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={9}>
        <UpdateClientFollowMappingComponent onError={notify.mutationError} onCompleted={editNotify}>
          {mutation => (
            <DepartmentPicker
              selectedDepartmentIds={ids}
              onDepartmentChange={(departmentIds: DepartmentIds) =>
                handleChange(mutation, departmentIds)
              }
              saving={saving}
            />
          )}
        </UpdateClientFollowMappingComponent>
      </Grid>
    </Grid>
  );
};

export default DepartmentsEdit;
